import { ReactNode } from 'react';

import { liveChatContext, LiveChatContextValue } from 'src/components/v2/LiveChat/LiveChatContext/liveChatContext';

type LiveChatContextProviderProps = {
  value: LiveChatContextValue;
  children: ReactNode | ReactNode[];
};

export function LiveChatContextProvider(props: LiveChatContextProviderProps) {
  return <liveChatContext.Provider value={props.value}>{props.children}</liveChatContext.Provider>;
}
